/**
 * panelr.ts - Panelr (Panel Management) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1540 [pending] danielbeer: Initial creation
 */

export const panelrModule = {
  id: 'ui-panelr',
  name: 'Panel Management',
  icon: '🗂️',
  category: 'modules',
  order: 10,
  
  // Package metadata for info panel
  packageInfo: {
    name: '@opcentral/panelr',
    version: '0.2.0',
    displayVersion: '0.2.0',
    description: 'Universal panel and sidebar management for OpCentral',
    status: 'implemented',
    implementationProgress: 90,
    dependencies: {
      '@opcentral/core': '*',
      '@opcentral/actr': '*',
      'react': '^18.0.0'
    },
    keywords: ['panels', 'sidebars', 'layout', 'ui', 'navigation'],
    author: 'OpCentral Team',
    license: 'MIT'
  },
  
  settings: {
    defaultPanelPosition: {
      type: 'select',
      label: 'Default Panel Position',
      description: 'Where panels appear by default',
      defaultValue: 'right',
      options: [
        { label: 'Left', value: 'left' },
        { label: 'Right', value: 'right' },
        { label: 'Top', value: 'top' },
        { label: 'Bottom', value: 'bottom' }
      ]
    },
    
    enablePanelResize: {
      type: 'boolean',
      label: 'Resizable Panels',
      description: 'Allow panels to be resized',
      defaultValue: true
    },
    
    rememberPanelState: {
      type: 'boolean',
      label: 'Remember Panel State',
      description: 'Save panel open/closed state',
      defaultValue: true
    },
    
    animatePanels: {
      type: 'boolean',
      label: 'Animate Panels',
      description: 'Show smooth transitions when opening/closing',
      defaultValue: true
    },
    
    defaultPanelWidth: {
      type: 'number',
      label: 'Default Panel Width (px)',
      description: 'Initial width for side panels',
      defaultValue: 300,
      min: 200,
      max: 800
    }
  }
};

export default panelrModule;
